import { findSimilarOSAcquisitionStudent } from './findSimilarOSAcquisitionStudent.js';
import { removeOSAcquisitionTagStudent } from './removeOSAcquisitionTag.js';
import { sendRelevantChangeNotificationEmail } from './sendIntensiveCourseStudentChangedEmail.js';
import { setSavedCampusSections as setSavedCampusSectionsMut } from './setSavedCampusSections.js';

export namespace StudentAPI {
  export const findSimilarOSAcquisition = findSimilarOSAcquisitionStudent;
  export const removeOSAcquisitionTag = removeOSAcquisitionTagStudent;
  export const setSavedCampusSections = setSavedCampusSectionsMut;
  export const sendIntensiveCourseStudentChanged = sendRelevantChangeNotificationEmail;
}
